import { render, staticRenderFns } from "./InsightsFilters.vue?vue&type=template&id=5b1603c8"
import script from "./InsightsFilters.vue?vue&type=script&lang=js"
export * from "./InsightsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports